// src/index.js

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";  // ✅ Import this

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter> {/* ✅ Wrap App in BrowserRouter */}
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            border: '1px solid #713200',
            padding: '16px',
            color: '#713200',
            fontSize: '2rem',
            fontFamily: "Passion One"
          },
        }}
      />
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);

reportWebVitals();




// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import { Provider } from "react-redux";
// import store from "./store";
// import { Toaster } from 'react-hot-toast';

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   // <React.StrictMode>
//     <Provider store={store}>
//       <App />
//       <Toaster 
//        position="top-right"
//        toastOptions={{
//         style: {
//           border: '1px solid #713200',
//           padding: '16px',
//           color: '#713200',
//           fontSize:'2rem',
//           fontFamily:"Passion One"
//         },
//       }}
//       />
//     </Provider>
//   //  </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
